class BenefitGroupStatusChangedSystemNotificationPayload {
  constructor(systemNotificationPayloadData = {}) {
    this.benefitGroupName = systemNotificationPayloadData.benefit_group_name || "";
    this.status = systemNotificationPayloadData.status ?? null;
  }
}

export default BenefitGroupStatusChangedSystemNotificationPayload;
